(ns frontend.react.virtualized.utils
  (:require [reagent.core :as r]))

(defn recompute-grid-sizes-with-state! [grid-store]
  ;; ensure state changes are rendered before we try recomputing column
  ;; widths / grid sizes:
  (r/after-render
   (fn []
     (let [header-grid (-> @grid-store :header-grid)
           recompute-header-fn (when header-grid
                                 (aget header-grid "recomputeGridSize"))
           content-grid (-> @grid-store :content-grid)
           recompute-content-fn (when content-grid
                                  (aget content-grid "recomputeGridSize"))]
       (when recompute-header-fn
         (.call recompute-header-fn header-grid))
       (when recompute-content-fn
         (.call recompute-content-fn content-grid))))))
